export const AppRoutes = {
  HOME: "/home",
  CALENDAR: "/calendar",
  PROJECT_GALLERY: "/project-gallery",
  LOGIN: "/login",
  LANDING: "/",
  BLOCK_JAM: "/BlockJam",
  MY_PROJECTS: "/my-projects",
  USER_PROFILE: "/user-profile",
  TEXT_JAM: "/TextJam",
  CURRICULUM: "/gwc",
}